/** @module cardData */

import * as constant from "./constants";

export const cardDictionary = {
  CARD_1: {
    name: "Grey 1",
    type: constant.POMP,
    number: 1,
    color: "G",
    count: 4,
    grid: ["1_0", "1_1"]
  },
  CARD_2: {
    name: "Purple 2",
    type: constant.POMP,
    number: 2,
    color: "P",
    count: 4,
    grid: ["0_4", "1_4"]
  },
  CARD_3: {
    name: "Purple 3",
    type: constant.POMP,
    number: 3,
    color: "P",
    count: 5,
    grid: ["2_2", "2_3"]
  },
  CARD_4: {
    name: "Grey 4",
    type: constant.POMP,
    number: 4,
    color: "G",
    count: 7,
    grid: ["2_5", "2_6"]
  },
  CARD_5: {
    name: "Purple 5",
    type: constant.POMP,
    number: 5,
    color: "P",
    count: 4,
    grid: ["2_8"]
  },
  CARD_6: {
    name: "Turquoise 6",
    type: constant.POMP,
    number: 6,
    color: "T",
    count: 7,
    grid: ["3_2", "3_3", "4_2", "4_3"]
  },
  CARD_7: {
    name: "Purple 7",
    type: constant.POMP,
    number: 7,
    color: "P",
    count: 3,
    grid: ["4_5"]
  },
  CARD_8: {
    name: "Grey 8",
    type: constant.POMP,
    number: 8,
    color: "G",
    count: 5,
    grid: ["3_6", "4_6"]
  },
  CARD_9: {
    name: "Turquoise 9",
    type: constant.POMP,
    number: 9,
    color: "T",
    count: 4,
    grid: ["5_4"]
  },
  CARD_10: {
    name: "Brown 10",
    type: constant.POMP,
    number: 10,
    color: "B",
    count: 5,
    grid: ["5_5", "6_5"]
  },
  CARD_11: {
    name: "Brown 11",
    type: constant.POMP,
    number: 11,
    color: "B",
    count: 5,
    grid: ["5_8", "6_8", "5_10", "6_10"]
  },
  OMEN: {
    name: "Omen",
    type: constant.OMEN,
    number: 0,
    color: "S",
    count: 7
  },
  AD79: {
    name: "AD 79",
    type: constant.AD79,
    number: 0,
    color: "S",
    count: 2
  }
};
